import * as React from 'react';
import styled from 'styled-components';

export const TotalsGrid = styled.div<{ children?: React.ReactNode; style?: React.CSSProperties }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: var(--spacer-S);
    top-bottom: var(--spacer-M);
    margin-bottom: var(--spacer-M);
`;

export const StatCard = styled.div<{ accent: string; children?: React.ReactNode; style?: React.CSSProperties; onClick?: () => void }>`
    background: var(--bg-light);
    border-radius: 6px;
    padding: var(--spacer-M);
    border-left: var(--border-thick) solid ${p => p.accent};
    display: flex;
    flex-direction: column;
    gap: var(--spacer-XS);
`;

export const CardLabel = styled.div`
    font-size: 0.8rem;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 600;
`;

export const CardValue = styled.div<{ textColor: string; children?: React.ReactNode }>`
    font-size: 1.6rem;
    font-weight: 700;
    color: ${p => p.textColor};
    line-height: 1;
    margin-bottom: var(--spacer-XXS);
`;

export const CardSubValue = styled.div`
    font-size: 0.78rem;
    color: var(--text-muted);
`;
